/** Szersze sekcje landingu (~1367px). */
export const LANDING_WIDE_COL_PROPS = {
    lg: 16,
    md: 12,
    sm: 4
    // noGutter: true
} as const;

/** Maks. rozmiar sekcji hero market news. Obrazek zajmuje połowę szerokości, czyli 957.5x705 (aspect 1.358). */
export const LANDING_FEATURED_MAX_WIDTH_PX = 1915;
export const LANDING_FEATURED_MAX_HEIGHT_PX = 705;

/** Hero market news – tło full width, kontent ~1200px. */
export const LANDING_FEATURED_COL_PROPS = {
    lg: 14,
    md: 12,
    sm: 4
} as const;

export const LANDING_MARKET_NEWS_COLORS = {
    accentYellow: "#eeff00",
    panelDark: "#23232d",
    panelLight: "#fafaf5",
    badgeOrange: "#ff6b35",
    recommendedPanelBg: "#e1d7cd",
    tabActiveBg: "#e8e8e0"
} as const;
